import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, Star } from "lucide-react";
import { api, imgUrl } from "@/api";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ProductForm } from "./ProductForm";

export const ProductsTab = ({ products, categories, onChange }) => {
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);

  const del = async (p) => {
    if (!window.confirm(`"${p.title}" silinsin mi?`)) return;
    try {
      await api.delete(`/products/${p.id}`);
      toast.success("Ürün silindi");
      onChange();
    } catch {
      toast.error("Silme başarısız");
    }
  };

  const catName = (slug) => categories.find((c) => c.slug === slug)?.name || slug;

  return (
    <div data-testid="products-tab">
      <div className="flex justify-between items-center mb-6">
        <p className="text-sm text-stone-500 font-light">{products.length} ürün listeleniyor</p>
        <Button
          onClick={() => { setEditing(null); setOpen(true); }}
          className="bg-stone-900 hover:bg-wood text-stone-50 rounded-none"
          data-testid="add-product-button"
        >
          <Plus size={15} className="mr-2" /> Yeni Ürün
        </Button>
      </div>

      <div className="bg-white border border-stone-200 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Görsel</TableHead>
              <TableHead>Başlık</TableHead>
              <TableHead>Kategori</TableHead>
              <TableHead>Öne Çıkan</TableHead>
              <TableHead className="text-right">İşlemler</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {products.map((p) => (
              <TableRow key={p.id} data-testid={`product-row-${p.id}`}>
                <TableCell>
                  <img src={imgUrl(p.image_url)} alt={p.title} className="h-14 w-14 object-cover bg-beige-soft" loading="lazy" />
                </TableCell>
                <TableCell className="font-medium text-stone-800">{p.title}</TableCell>
                <TableCell className="text-stone-500">{catName(p.category)}</TableCell>
                <TableCell>{p.featured && <Star size={15} className="text-wood-light fill-wood-light" />}</TableCell>
                <TableCell className="text-right">
                  <button onClick={() => { setEditing(p); setOpen(true); }} className="p-2 text-stone-500 hover:text-stone-900" data-testid={`edit-product-${p.id}`} aria-label="Düzenle">
                    <Pencil size={15} />
                  </button>
                  <button onClick={() => del(p)} className="p-2 text-stone-500 hover:text-red-700" data-testid={`delete-product-${p.id}`} aria-label="Sil">
                    <Trash2 size={15} />
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <ProductForm
        open={open}
        onClose={() => setOpen(false)}
        product={editing}
        categories={categories}
        onSaved={() => { setOpen(false); onChange(); }}
      />
    </div>
  );
};
